// extracted by mini-css-extract-plugin
export var circle = "_2y-2";
export var icon = "_2y-a";
export var iconHighlight = "_2y-0";
export var lg = "_2y-8";
export var md = "_2y-7";
export var outline = "_2y-4";
export var sm = "_2y-6";
export var square = "_2y-1";
export var xl = "_2y-9";
export var xs = "_2y-5";
export var xxs = "_2y-3";